export const getThisYear = () => {
    const now = new Date();
    const year = now.getFullYear();

	return year;
}
